import axiosInstance from 'axiosInstance';
import { useRouter } from 'next/router';
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { authActions } from "store/auth/auth-slice";
import { toast } from "react-toastify";

const LoginForm = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [phone, setPhone] = useState('');
  const [showOTPForm, setShowOTPForm] = useState(false);
  const [otp, setOTP] = useState('');
  const [countdown, setCountdown] = useState(120);

  const otpInputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];
  useEffect(() => {
    let intervalId;
    if (countdown > 0 && showOTPForm) {
      intervalId = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [countdown, showOTPForm]);

  const handleLoginClick = () => {

    // Validate phone number
    if (!phone || phone.trim() === '') {
      toast.error("Phone number can not be empty ");
      return;
    }
  
    if (phone.trim().length < 11) {
      toast.error("Please enter a valid phone number with at least 10 digits");
      return;
    }

    // For now, let's just toggle the showOTPForm state and clear the OTP input
    setShowOTPForm(true);
    setOTP('');
    setCountdown(120); 

    // Call the API to generate OTP
    axiosInstance.post('/api/login/generate-otp', { phone })
      .then((response) => {
        // Handle the response from the API
        
      })
      .catch((error) => {
        // Handle any errors
        console.error('Failed to generate OTP:', error);
      });
  };

  const handleOTPChange = (index, value) => {
    const updatedOTP = otp.split('');
    updatedOTP[index] = value;
    setOTP(updatedOTP.join(''));

    if (value !== '' && index < otpInputRefs.length - 1) {
      otpInputRefs[index + 1].current.focus();
    }
  };

  const handleOTPSubmit = (e) => {
    e.preventDefault();
    axiosInstance.post('/api/login/verify-otp', { phone, otp })
      .then((response) => {
        if (response.data?.login) {
          toast.success("Logged In Successfully!");
          localStorage.setItem("accessToken", response.data.token);
          localStorage.setItem("user", JSON.stringify(response.data.user));
          localStorage.setItem("isLoggedIn", true);
          dispatch(authActions.setAccessToken(response.data.token));
          dispatch(authActions.setUser(response.data.user));
          dispatch(authActions.setIsLoggedIn(true));
          const previousPage = localStorage.getItem("previousPage");
          if (previousPage) {
            localStorage.removeItem("previousPage");
            router.push(previousPage);
          } else {
            router.push("/app");
          }
        } else {
          console.log('Login failed');
        }
      })
      .catch((error) => {
        // Handle any errors
        console.error('Failed to verify OTP:', error);
        toast.error(error.response.data.message)
      });
  };

  const handleBackClick = () => {
    setShowOTPForm(false);
    setPhone('');
    setOTP('');
  };
  const skipClick =()=> {
    router.push('/app')
  }

  if (showOTPForm) {
    // Render OTP form if showOTPForm is true
    return (
      <>
        <section className="topBar">
        <div className="left-wrrow" onClick={handleBackClick}>
          <span className="iconWrapper">
            <svg
              width="6"
              height="12"
              viewBox="0 0 6 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.46849 0.414376C5.79194 0.673133 5.84438 1.1451 5.58562 1.46855L1.96044 6.00003L5.58562 10.5315C5.84438 10.855 5.79194 11.3269 5.46849 11.5857C5.14505 11.8444 4.67308 11.792 4.41432 11.4685L0.414321 6.46855C0.195189 6.19464 0.195189 5.80542 0.414321 5.53151L4.41432 0.531506C4.67308 0.20806 5.14505 0.155619 5.46849 0.414376Z"
                fill="#333333"
              />
            </svg>
          </span>
        </div>
        <div className="middleContent">
          <h3>OTP</h3>
        </div>
        <div className="rightContent"></div>
      </section>
      <section className="headerGap"></section>
      <div className='login-form-wrapper'>
        <h2>Enter OTP</h2>
        <form onSubmit={handleOTPSubmit} className="otp-form">
          <div className="otp-input-container">
            {otpInputRefs.map((ref, index) => (
              <input
                key={index}
                type='number'
                maxLength="1"
                value={otp[index] || ''}
                onChange={(e) => handleOTPChange(index, e.target.value)}
                ref={ref}
              />
            ))}
          </div>
          <button type="submit" className='submitBtn'>Submit</button>
          <span className='countdown'>Time Remaining: {countdown} seconds</span>
        </form>
      </div> 
      </>
    );
  } else {
    // Render login form with phone input and login button
    return (
      <div className="container">
        <div className='login-form-wrapper'>
        <h2>Agricare </h2>
        <form className="login-form">
          <div className="inputBox">
            <label htmlFor="eamailPhone" className="inputBox-label">Phone Number</label>
            <input type="text" id="eamailPhone" placeholder="Enter phone " autoComplete='off' className="inputBox-input" 
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <button
              className={`submitBtn ${phone.length !== 11 ? 'disabled' : ''}`}
              type="button"
              onClick={handleLoginClick}
              disabled={phone.length !== 11}
            >
              Continue
            </button>
          <span className='skip' onClick={skipClick}>Skip for Now</span>
        </form>
      </div>
      </div>
    );
  }
};

export default LoginForm;
